import { MatDialog, MatDialogRef } from "@angular/material";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../shared/services/user/user.service";
import { TranslateService } from "@ngx-translate/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
//encapsulation: ViewEncapsulation.None
export class LoginComponent implements OnInit, OnDestroy {
  currentYear: number;
  authForm: FormGroup;
  mfaAuthForm: FormGroup;
  isAuthenticated:boolean=true;
  isSendOtp:boolean=false;
  isDeviceLost:boolean=false;
  QRCode:string;
  isSubmitted: number = 0;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();  

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public translate: TranslateService,
    private userService: UserService,
    private dialog: MatDialog
  ) {
    translate.get("LOGIN.InvalidUserName").subscribe((res: string) => {
      //use this to have text in componenet
      console.log(res);
    });
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.createForm();
  }

  setSeletedLanguage(){
    localStorage.setItem("language", this.authForm.get("selectLanguageControl").value);
    this.translate.use(this.authForm.get("selectLanguageControl").value);
  }
  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  createForm() {
    this.authForm = this.fb.group({
      username: [
        "",
        Validators.compose([Validators.required, Validators.email])
      ],
      password: ["", Validators.required],
      otp: [""],
      selectLanguageControl:["en"]
    });
    if(localStorage.getItem("language")){
      this.authForm.get("selectLanguageControl").setValue(localStorage.getItem("language"));
      this.authForm.get("selectLanguageControl").updateValueAndValidity();
      this.translate.use(localStorage.getItem("language"));
    }
  };

  setValidationOnOTP() {
    this.isSendOtp = true;
    this.authForm.get('otp').clearValidators();
    this.authForm.get('otp').setValidators([Validators.required,Validators.pattern(/^[0-9]\d*$/)]);
    this.authForm.get('otp').updateValueAndValidity();
  };

  createMFAAuthForm() {
    this.mfaAuthForm = this.fb.group({
      username: [this.authForm.value.username, Validators.compose([Validators.required, Validators.email]) ],
      password: [this.authForm.value.password, Validators.required],
      otp: ["", Validators.compose([Validators.required,Validators.pattern(/^[0-9]\d*$/)])]
    });
  };

  onSubmit(form: any) {
    if (!this.authForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    let userName = form.username;
    let password = form.password;
    let otp = form.otp;
    if(!otp || otp == ""){
        this.userService.checkMFAAuth(userName, password).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
          this.isSubmitted = 0;
          if(res && !res.enableMFA){
            this.login(userName,password,otp);
          }else{
            if(res && !res.isAuthenticated && !res.authQRCode){
              return;
            }
            else if(res && (!res.isAuthenticated || !res.secretKey)){
              this.isAuthenticated = false;
              this.QRCode = res.authQRCode;
              this.createMFAAuthForm();
            }else{
              this.setValidationOnOTP()
            }
          }
        },
        (err: any) => {
          this.isSubmitted = 0;
        }
      );
    }else{
      this.login(userName,password,otp);
      // this.userService.login(userName, password, otp).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      //   r => {
      //     this.router.navigate(["/dashboard"]);
      //     this.userService.redirectToHome(this.router);
      //     this.isSubmitted = 0;
      //   },
      //   (err: any) => {
      //     localStorage.clear();
      //     this.isSubmitted = 0;
      //   }
      // );
    }
  };
  
  onVerifyAuth(form: any){
    if (!this.mfaAuthForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    let userName = form.username;
    let password = form.password;
    let otp = form.otp;
    this.login(userName,password,otp);
  }

  login(email:string,password:string,otp:string){
    this.userService.login(email, password, otp).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      r => {
        this.router.navigate(["/dashboard"]);
        this.userService.redirectToHome(this.router);
        this.isSubmitted = 0;
      },
      (err: any) => {
        localStorage.clear();
        this.isSubmitted = 0;
      }
    );
  }

  openForgotPasswordDialog() {
    this.dialog.open(ForgotPasswordDialog, {
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    })
  };

  showLostDeviceMSG() {
    this.isDeviceLost = !this.isDeviceLost;
  };

  redirectToLogin() {
    // this.router.navigate(["/login"]);
    // window.location.href="/login";
    window.location.reload();
  };
}

@Component({
  selector: "forgot-password-dialog",
  templateUrl: "forgot-password.dialog.html"
})
export class ForgotPasswordDialog implements OnDestroy {
  forgotPasswordForm: FormGroup;
  isSubmitted: number = 0;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    public dialogRef: MatDialogRef<ForgotPasswordDialog>
  ) {
    this.createForm();
  }

  createForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ["", Validators.required]
    });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onSubmit(form) {
    if (!this.forgotPasswordForm.valid) {
      return;
    }
    this.isSubmitted = 1;
    // console.log(form);
    this.userService.forgotPassword(form).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.isSubmitted = 0;
      this.dialogRef.close();
    }, err => {
      this.isSubmitted = 0;
    });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/login/login.component.ts